// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"UserTasks_tabPanel__sCFqV"};